
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorPlayersProfileNavigationVue from "@/components/administrator/players/profile/navigation.vue";
import AdministratorPlayersProfileDiagnosticsFilterIndexVue from "@/views/app/administrator/players/profile/diagnostics/filter/index.vue";
import AdministratorPlayersProfileDiagnosticsListIndexVue from "@/views/app/administrator/players/profile/diagnostics/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorPlayersProfileNavigationVue,
    AdministratorPlayersProfileDiagnosticsFilterIndexVue,
    AdministratorPlayersProfileDiagnosticsListIndexVue
  },
})
export default class AdministratorPlayersProfileDiagnosticsIndexVue extends Vue {
  isLoading: boolean | null = false;

  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  $refs!: {
    AdministratorPlayersProfileDiagnosticsListIndexVue: any;
  };

  getDiagnosticsByFilter(formData: any): void {
    this.$refs.AdministratorPlayersProfileDiagnosticsListIndexVue.getDiagnostics(formData);
  }

  async getDiagnosticCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/diagnostic-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diagnosticCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getDiagnosticCategories();
  }
}
